const sanitiseUrlPath = value => {
  if (typeof value === 'string' && value.charAt(0) === '/') {
    return value.substr(1);
  }
  return value;
};

export default sanitiseUrlPath;
